import * as React from 'react';
import { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
/*
  README
  This is an automatically generated file and should not be edited manually.
  All changes should be made via 'make build-react-icons'
*/
const SvgDownloadSimple = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={28}
    height={28}
    viewBox="0 0 28 28"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M24.5 15.75v7a.875.875 0 0 1-.875.875H4.375a.875.875 0 0 1-.875-.875v-7a.875.875 0 1 1 1.75 0v6.125h17.5V15.75a.875.875 0 1 1 1.75 0Zm-11.12.62a.876.876 0 0 0 1.24 0l4.374-4.376a.875.875 0 0 0-1.238-1.238l-2.881 2.882V3.5a.875.875 0 0 0-1.75 0v10.138l-2.88-2.882a.876.876 0 0 0-1.24 1.238l4.376 4.375Z" />
  </svg>
);
export default SvgDownloadSimple;
